<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
    <ToastContainer />
  </v-app>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ToastContainer from "@/components/ToastContainer.vue";

export default defineComponent({
  name: "App",
  components: { ToastContainer },
});
</script>

<style>
/* Typography and brand tokens live in src/assets/brand.css. */
</style>
